// src/context/GameContext.jsx
import React, { createContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

export const GameContext = createContext();

export const GameProvider = ({ socket, gameState, children }) => {
  const [playerId] = useState(() => crypto.randomUUID());

  const joinLobby = (name) => {
    if (!socket || !name) return;
    // Prevent double join
    if (gameState?.players?.some(p => p.socketId === socket.id)) return;

    // Always generate a fresh gameId to avoid joining old games
    const gameId = uuidv4();
    localStorage.setItem('gameId', gameId);

    // Sync URL
    const params = new URLSearchParams(window.location.search);
    params.set('gameId', gameId);
    window.history.replaceState({}, '', `${window.location.pathname}?${params}`);

    socket.emit('joinLobby', { playerId, name, gameId, isAI: false });
  };

  const startGame = (teamMode = '2v2') => {
    const gameId = localStorage.getItem('gameId');
    if (!gameId) return;
    socket.emit('startGame', { gameId, teamMode });
  };

  return (
    <GameContext.Provider value={{ socket, gameState, playerId, joinLobby, startGame }}>
      {children}
    </GameContext.Provider>
  );
};
